export default __webpack_public_path__ + "static/media/LH3-LEARNING-HUB.5dcd3d86.jpg";